import {getId, getType} from 'apis/model/base'
import React, {useCallback, useContext, useMemo} from 'react'
import {PiMonitorLight,} from 'react-icons/pi'
import {compose, fromRenderProps, nest, withProps} from 'recompose'
import {DelayRender} from 'views/Shared/components/DelayRender'
import {SettingsMenu} from 'views/AppLocals/factory/createSettingLayout'
import {renderOwnChild} from 'views/Shared'
import CustomSiderMenu from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceContext from '../WorkspaceContext';
import useTranslate from "../../../modules/local/useTranslate";
import ShopDashboard from "./containers/ShopDashboard";
import ShopContainer from "./containers/ShopContainer";
import {IoStorefrontOutline} from "react-icons/io5";

const ItemKeys = Object.freeze({
    DASHBOARD: 'dashboard',
    SHOPS: 'shops',
    PRODUCTS: 'products',
    SETTINGS: 'settings',
    PRODUCT_CATALOGS: 'product_catalogs',
})

const WorkspaceShop = ({owner_id, owner_type}) => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext);
    const menuItems = useMemo(() => {
        const menuItems = [
            {
                key: ItemKeys.DASHBOARD,
                label: 'overview',
                icon: <PiMonitorLight size={16}/>,
            },
            {
                key: ItemKeys.SHOPS,
                label: 'shops',
                icon: <IoStorefrontOutline size={16}/>,
            },
        ]
        return menuItems;
    }, [])
    const routeEntities = useMemo(() => {
        const routeEntities = [
            {
                key: ItemKeys.DASHBOARD,
                component: ShopDashboard,
            },
            {
                key: ItemKeys.SHOPS,
                component: ShopContainer,
            },
        ].map(({key, ...rest}) => ({
            key,
            path: key,
            ...rest,
        }))
        return routeEntities;
    }, [])

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    const renderMenu = useCallback(
        () => (
            <CustomSiderMenu
                deps={[activeKey]}
                Wrapper={renderOwnChild}>
                <SettingsMenu
                    items={menuItems}
                    onSelect={onMenuSelect}
                    selectedKeys={[activeKey]}
                    // defaultSelectedKeys={[activeKey]}
                    defaultOpenKeys={[]}
                />
            </CustomSiderMenu>
        ),
        [menuItems, activeKey]
    )

    return (
        <div className="px-3 md:px-6">
            <Component {...{owner_id, owner_type}} />
        </div>
    )
}

export default nest(
    withProps({lazy: true})(DelayRender),
    compose(
        fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
            owner_id: getId(organization),
            owner_type: getType(organization),
        }))
    )(WorkspaceShop)
)
